import React from "react";
import { captureException } from "../../app/sentry";

/**
 * Section-level error boundary: a render error inside one card (e.g. a chart
 * choking on unexpected data) degrades to an inline error message instead of
 * white-screening the entire page.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error(`[ErrorBoundary${this.props.name ? `:${this.props.name}` : ""}]`, error, info);
    captureException(error, {
      react: {
        componentStack: info?.componentStack,
        boundary: this.props.name || "section",
      },
    });
  }

  render() {
    if (this.state.error) {
      return (
        <div className='py-8 px-4 text-center'>
          <p className='text-body-sm font-medium text-severity-high mb-1'>
            {this.props.name ? `${this.props.name} failed to render` : "This section failed to render"}
          </p>
          <p className='text-body-xs text-text-tertiary mb-3'>
            {String(this.state.error?.message || this.state.error)}
          </p>
          <button
            onClick={() => this.setState({ error: null })}
            className='px-3 py-1.5 text-body-xs font-medium rounded-lg border border-border-subtle hover:bg-surface-neutral transition-colors'
          >
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
